import type { WelcomePlaylistVideo } from './WelcomeVideo';

export const QUICK_INTRO_COOLDOWN_MS = 24 * 60 * 60 * 1000;
export const QUICK_INTRO_MAX_APPEARANCES = 2;

/** Older servers omit the policy; malformed values must never shorten the pause. */
export function welcomeCooldownMs(hours: unknown): number {
  return hours === 0 || hours === 2 || hours === 6 || hours === 12 || hours === 24
    ? hours * 60 * 60 * 1000 : QUICK_INTRO_COOLDOWN_MS;
}

export interface WelcomeVideoHistory {
  appearances: number;
  watched: boolean;
  retired: boolean;
}

/** Main is deliberate; the remaining videos keep the operator's chosen order. */
export function nextWelcomeVideo(
  videos: WelcomePlaylistVideo[],
  mainId: string | null,
  history: Readonly<Record<string, WelcomeVideoHistory>>,
): WelcomePlaylistVideo | undefined {
  const main = videos.find(video => video.id === mainId);
  const ordered = main ? [main, ...videos.filter(video => video.id !== main.id)] : videos;
  return ordered.find(video => {
    const previous = history[video.id];
    return !previous || (!previous.watched && !previous.retired && previous.appearances < QUICK_INTRO_MAX_APPEARANCES);
  });
}

export function welcomeCooldownElapsed(lastOpenedAt: number | null, now: number, intervalHours?: unknown): boolean {
  return Number.isFinite(now) && (lastOpenedAt === null ||
    (Number.isFinite(lastOpenedAt) && lastOpenedAt >= 0 && (intervalHours === 0 || now - lastOpenedAt >= welcomeCooldownMs(intervalHours))));
}
